import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import {
  DEFAULT_DELETE_CONFIG,
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_BANK_ACCOUNT,
  CLEAR_BANK_ACCOUNTS,
  FLAG_BANK_ACCOUNT_ACTIVITY,
  FLAG_GETTING_BANK_ACCOUNTS,
  GET_BANK_ACCOUNT,
  GET_BANK_ACCOUNTS,
} from '../types';
import { BANK_ACCOUNT_ENDPOINT } from '../../config/endpoints';
import { BANK_ACCOUNT_PATH } from '../../config/paths';

const flagGettingBankAccounts = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_BANK_ACCOUNTS,
    payload: flag,
  });

const getBankAccounts = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingBankAccounts(true));
    const query = tableFilters;
    const url = `${BANK_ACCOUNT_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const costCenters = await response.json();
    dispatch({
      type: GET_BANK_ACCOUNTS,
      payload: costCenters,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingBankAccounts(false));
  }
};

const clearBankAccounts = () => (dispatch) =>
  dispatch({
    type: CLEAR_BANK_ACCOUNTS,
  });

const flagBankActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_BANK_ACCOUNT_ACTIVITY,
    payload: flag,
  });

const getBankAccount =
  async ({ bankAccountId }) =>
  async (dispatch) => {
    try {
      dispatch(flagBankActivity(true));
      const url = `${BANK_ACCOUNT_ENDPOINT}/${bankAccountId}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const bank = await response.json();
      dispatch({
        type: GET_BANK_ACCOUNT,
        payload: bank,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagBankActivity(false));
    }
  };

const clearBankAccount = () => (dispatch) =>
  dispatch({
    type: CLEAR_BANK_ACCOUNT,
  });

const postBankAccount =
  async ({
    accountNumber,
    interbankNumber,
    currency,
    receipt,
    bankId,
    businessId,
    active,
    sunatTableCode,
    sysCode,
    orderNumber,
    externalAccountId,
  }) =>
  async (dispatch) => {
    try {
      dispatch(flagBankActivity(true));
      const payload = {
        accountNumber,
        interbankNumber,
        currency,
        receipt,
        bankId,
        businessId,
        active,
        sunatTableCode,
        sysCode,
        orderNumber,
        externalAccountId,
      };
      const url = BANK_ACCOUNT_ENDPOINT;
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const bank = await response.json();
      dispatch(push(`${BANK_ACCOUNT_PATH}/${bank.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagBankActivity(false));
    }
  };

const putBankAccount =
  async (
    bankAccountId,
    {
      accountNumber,
      interbankNumber,
      currency,
      receipt,
      bankId,
      businessId,
      active,
      sunatTableCode,
      sysCode,
      orderNumber,
      externalAccountId,
    },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagBankActivity(true));

      const payload = {
        id: bankAccountId,
        accountNumber,
        interbankNumber,
        currency,
        receipt,
        bankId,
        businessId,
        active,
        sunatTableCode,
        sysCode,
        orderNumber,
        externalAccountId,
      };

      const url = `${BANK_ACCOUNT_ENDPOINT}/${bankAccountId}`;
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });

      await isErrorResponse(response, null, dispatch);
      const bank = await response.json();
      dispatch(push(`${BANK_ACCOUNT_PATH}/${bank.id}`));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBankActivity(false));
    }
  };

const deleteBankAccount =
  async ({ bankAccountId }) =>
  async (dispatch) => {
    try {
      dispatch(flagBankActivity(true));
      const url = `${BANK_ACCOUNT_ENDPOINT}/${bankAccountId}`;
      const response = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      });
      await isErrorResponse(response, null, dispatch);
      await response.json();
      dispatch(push(BANK_ACCOUNT_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBankActivity(false));
    }
  };

export {
  getBankAccounts,
  clearBankAccounts,
  getBankAccount,
  clearBankAccount,
  postBankAccount,
  putBankAccount,
  deleteBankAccount,
};
